export const defineMessages = <T extends Record<string, string>>(
  messages: T
): T => {
  return messages;
};
